
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IGridLayoutSelector, IMetadataAction } from "@tylertech/tyler-api-types";

/**
 * GridLayoutService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GridLayoutService {
    constructor(private readonly $apiService: ApiService) { }
    
    LoadLayoutAction(selector: IGridLayoutSelector): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IGridLayoutService/LoadLayoutAction", selector);
    }
}
